import type { BaseSyntheticEvent } from 'react';

import { logger } from 'Services/logger/logger';

type ImageExceptionProps = {
	event: Pick<BaseSyntheticEvent, 'target'>;
	imageComponent: string;
	rootComponent: string;
};

export const captureImageException = ({ event, imageComponent, rootComponent }: ImageExceptionProps): void => {
	const message = 'Image failed to load';
	const error = new Error(message);
	error.name = 'ImageError';

	const extra = {
		imageComponent,
		rootComponent,
		srcUrl: event.target.currentSrc,
	};

	logger.warn({ context: { extra }, error, message, scope: 'captureImageException' });
};
